import { useContext } from 'react';
import { Box, LoadingOverlay } from '@mantine/core';
import { EventParticipationsContext } from '../../Service/Context/EventParticipationContextV2';
import { EmailBoxContextProvider } from '../../Service/Context/EmailBoxContext';
import EmailsSection from '../../Organismns/Message/EmailsSection';

const Messaging = () => {
  const { participations, loading } = useContext(EventParticipationsContext);

  if (loading) {
    return (
      <Box pos="relative" sx={{ height: '100%', width: '100%' }}>
        <LoadingOverlay visible loaderProps={{ size: 'xl' }} />
      </Box>
    );
  }

  if (participations.length === 0) return null;

  return (
    <EmailBoxContextProvider contactIds={participations.map((p) => p.contactId)}>
      <EmailsSection />
    </EmailBoxContextProvider>
  );
};

export default Messaging;
